/**
 * TODO: Decouple this component:
 * This file is a React Router 4 wrapper. It has a impure component
 * because it's  highly coupled to route configs and Login and NotFoundPage Components.
 * Can it will be an library in a not far distant future?
 *
 * TODO: Write some case tests for logged and not logged case
 */

import React from 'react'
import PropTypes from 'prop-types'
import { connect } from 'react-redux'
import { Routes as RouterRoutes, Route, Navigate } from 'react-router-dom'

import { privateRoutes, publicRoutes, notLoggedRoutes } from './pathUrls'
import NotFoundPage from '../pages/NotFoundPage'

import { getQueryString } from '../utils/url'

const mapStateToProps = state => {
  return {
    isLogged: state.auth.isLogged
  }
}

const Routes = ({ isLogged }) => {
  const defaultPrivateRoute = privateRoutes.find(route => route.default)
  const defaultPrivatePath = `${defaultPrivateRoute.path}${getQueryString()}`

  const renderRoute = (route, key) => {
    const { path, component: Component, template: Template } = route
    const element = Template ? (
      <Template>
        <Component />
      </Template>
    ) : (
      <Component />
    )
    return <Route key={key} path={path} element={element} />
  }

  const renderPrivateRoute = (route, key) => {
    const Component = isLogged ? route.component : () => <Navigate to={`/login${getQueryString()}`} replace />
    const Template = isLogged ? route.template : undefined
    const element = Template ? (
      <Template>
        <Component />
      </Template>
    ) : (
      <Component />
    )
    return <Route key={key} path={route.path} element={element} />
  }

  const renderNotLoggedRoute = (route, key) => {
    if (isLogged) {
      return <Route key={key} path={route.path} element={<Navigate to={defaultPrivatePath} replace />} />
    }
    return renderRoute(route, key)
  }

  const allRoutes = [
    ...privateRoutes.map((route, index) => renderPrivateRoute(route, `private-${index}`)),
    ...notLoggedRoutes.map((route, index) => renderNotLoggedRoute(route, `notlogged-${index}`)),
    ...publicRoutes.map((route, index) => renderRoute(route, `public-${index}`))
  ]

  return (
    <RouterRoutes>
      {allRoutes}
      <Route path='*' element={<NotFoundPage />} />
    </RouterRoutes>
  )
}

Routes.propTypes = {
  isLogged: PropTypes.bool.isRequired
}

export default connect(mapStateToProps)(Routes)
